/**
 * TODO Get rid of angularjs, director, bad api etc, etc.
 *
 * @module
 *
 * @author Jacob Viertel [jv@onscreen.net](mailto:jv@onscreen.net)
 *
 * @since 3.102.0
 */
import {BOOLEAN, guard, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';
import {post} from '../../core/service/backend.js';
import {inject, ngDigest} from '../../core/service/ng.js';
import {t} from '../../locale/config/translate.js';

const url = 'user/signup';

/**
 * @param {HTMLElement} element
 * @param {Valid<REQUEST>} data May be validated by {@link valid}
 *
 * @returns {Promise<void>}
 */
const signup = async (element, data) => {
  const result = await post(url, data, element);
  ASSERT: guard(result, RESPONSE, `${url} api response`);

  if (result.reactivationMailSent) {
    await popup(element).warn(await t('userPool.reactivationMailSent'));

    return;
  }

  inject('$rootScope').$broadcast('userPool.signup.success', result);
  ngDigest();

  /**
   * @deprecated
   */
  const director = inject('director');

  director.setSignupEmail(data.email);

  if (result.passwordResetToken) {
    director.setPasswordResetToken(result.passwordResetToken);
  }

  inject('onsOverlay').get('signup')?.close();

  if (inject('user').guest) {
    director.triggerUserPopups();
  }
};

/**
 * @param {unknown} data
 *
 * @returns {asserts data is Valid<REQUEST>}
 */
const valid = (data) => guard(data, REQUEST, `${url} request data`);

/**
 * Validate the signup request body.
 */
const REQUEST = /* @__PURE__ */ (() =>
  OBJECT({
    nickname: STRING,
    email: STRING,
    password: OPTIONAL(STRING),
    termsAccepted: OPTIONAL(STRING),
  }))();

/**
 * Validate the decoded signup response body.
 */
const RESPONSE = /* @__PURE__ */ (() =>
  OBJECT({
    passwordResetToken: OPTIONAL(STRING),
    reactivationMailSent: OPTIONAL(BOOLEAN),
  }))();

export {valid, signup};
